/**
 * babillard.js
 */

// Import
import "./babillard.scss";
import $ from 'jquery';

$(document).ready(function() {

});